import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _aggregationData = { results: '_aggregationResults' };
var _aggregationNestedAggregation = {
    nestedAggregations: '_nestedAggregationNestedAggregationItem',
};
var _aggregationRangeAggregation = {
    buckets: '_rangeAggregationRangeBucket',
};
var _aggregationResults = {
    ranges: '_rangeResults',
    scalar: '_aggregationResultsScalarResult',
    groupedByValue: '_groupByValueResults',
    nested: '_nestedResults',
};
var _aggregationResultsScalarResult = { value: 'DOUBLE' };
var _appEmbedData = { image: '_media' };
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _bulkAddItemsToCategoryRequest = {};
var _bulkAddItemsToCategoryResponse = {};
var _bulkAddItemToCategoriesRequest = {};
var _bulkAddItemToCategoriesResponse = {};
var _bulkCategoriesResult = { category: '_category' };
var _bulkCreateCategoriesRequest = { categories: '_category' };
var _bulkCreateCategoriesResponse = { results: '_bulkCategoriesResult' };
var _bulkDeleteCategoriesByFilterRequest = {};
var _bulkDeleteCategoriesByFilterResponse = {};
var _bulkDeleteCategoriesRequest = {};
var _bulkDeleteCategoriesResponse = {};
var _bulkRemoveItemFromCategoriesRequest = {};
var _bulkRemoveItemFromCategoriesResponse = {};
var _bulkRemoveItemsFromCategoryRequest = {};
var _bulkRemoveItemsFromCategoryResponse = {};
var _bulkUpdateCategoriesRequest = { categories: '_maskedCategory' };
var _bulkUpdateCategoriesResponse = { results: '_bulkCategoriesResult' };
var _bulkUpdateCategoryVisibilityByFilterRequest = {};
var _bulkUpdateCategoryVisibilityByFilterResponse = {};
var _bulkUpdateCategoryVisibilityRequest = {};
var _bulkUpdateCategoryVisibilityResponse = {
    results: '_bulkCategoriesResult',
};
var _category = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    image: '_image',
    richContentDescription: '_richContent',
};
var _categoryTreeNode = { id: 'BYTES', subcategories: '_categoryTreeNode' };
var _commonAggregation = {
    range: '_aggregationRangeAggregation',
    nested: '_aggregationNestedAggregation',
};
var _countCategoriesRequest = {};
var _countCategoriesResponse = {};
var _createCategoryRequest = { category: '_category' };
var _createCategoryResponse = { category: '_category' };
var _cursorSearch = { aggregations: '_commonAggregation' };
var _deleteCategoryRequest = {};
var _deleteCategoryResponse = {};
var _design = { poll: '_pollDesign' };
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getArrangedItemsRequest = {};
var _getArrangedItemsResponse = {};
var _getCategoriesTreeRequest = {};
var _getCategoriesTreeResponse = { categoriesTree: '_categoryTreeNode' };
var _getCategoryRequest = {};
var _getCategoryResponse = { category: '_category' };
var _groupByValueResults = { results: '_nestedValueAggregationResult' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _imageData = { image: '_media' };
var _item = { image: '_itemImage', video: '_video' };
var _itemImage = { media: '_media' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _listCategoriesForItemRequest = {};
var _listCategoriesForItemResponse = {};
var _listCompactCategoriesByIdsRequest = {};
var _listCompactCategoriesByIdsResponse = {};
var _listItemsInCategoryRequest = {};
var _listItemsInCategoryResponse = {};
var _listTreesRequest = {};
var _listTreesResponse = {};
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _maskedCategory = {
    fieldMask: 'google.protobuf.FieldMask',
    category: '_category',
};
var _media = { duration: 'google.protobuf.DoubleValue' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _moveCategoryRequest = {};
var _moveCategoryResponse = {};
var _moveItemInCategoryRequest = {};
var _moveItemInCategoryResponse = {};
var _nestedAggregationNestedAggregationItem = {
    range: '_aggregationRangeAggregation',
};
var _nestedAggregationResults = {
    ranges: '_rangeResults',
    scalar: '_aggregationResultsScalarResult',
};
var _nestedResults = { results: '_results' };
var _nestedResultValue = { range: '_rangeResult', scalar: '_scalarResult' };
var _nestedValueAggregationResult = {
    nestedResults: '_nestedAggregationResults',
};
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _option = { image: '_media' };
var _poll = { image: '_media', options: '_option' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _queryCategoriesRequest = {};
var _queryCategoriesResponse = { categories: '_category' };
var _rangeAggregationRangeBucket = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeAggregationResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResults = { results: '_rangeAggregationResult' };
var _results = { results: 'Map#_nestedResultValue' };
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _scalarResult = { value: 'DOUBLE' };
var _searchCategoriesRequest = { search: '_cursorSearch' };
var _searchCategoriesResponse = {
    categories: '_category',
    aggregationData: '_aggregationData',
};
var _setArrangedItemsRequest = {};
var _setArrangedItemsResponse = {};
var _updateCategoryRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    category: '_category',
};
var _updateCategoryResponse = { category: '_category' };
var _updateCategoryVisibilityRequest = {};
var _updateCategoryVisibilityResponse = { category: '_category' };
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
function resolveComWixCategoriesApiV1CategoriesServiceUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/categories',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/categories/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/categories/v1/categories',
                destPath: '/v1/categories',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/categories',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a category. */
export function createCategory(payload) {
    var _a = serializer(_createCategoryRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _category: _category,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCategoryResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _category: _category,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __createCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.CreateCategory',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCategory.fromReq = fromReq;
    __createCategory.__isAmbassador = true;
    return __createCategory;
}
/** Retrieves a category. */
export function getCategory(payload) {
    var _a = serializer(_getCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCategoryResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _category: _category,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __getCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'GET',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.GetCategory',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/{categoryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCategory.fromReq = fromReq;
    __getCategory.__isAmbassador = true;
    return __getCategory;
}
/**
 * Updates a category.
 *
 * Each time the category is updated, `revision` increments by 1.
 * The current `revision` must be passed when updating the category.
 * This ensures you're working with the latest category and prevents unintended overwrites.
 */
export function updateCategory(payload) {
    var _a = serializer(_updateCategoryRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _category: _category,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCategoryResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _category: _category,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __updateCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'PATCH',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.UpdateCategory',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/{category.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCategory.fromReq = fromReq;
    __updateCategory.__isAmbassador = true;
    return __updateCategory;
}
/** Deletes a category. */
export function deleteCategory(payload) {
    var _a = serializer(_deleteCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCategoryResponse, {}).fromJSON;
    function __deleteCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'DELETE',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.DeleteCategory',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/{categoryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCategory.fromReq = fromReq;
    __deleteCategory.__isAmbassador = true;
    return __deleteCategory;
}
/** Query Categories using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).  Use instead of Search when eventually consistent data is not acceptable */
export function queryCategories(payload) {
    var _a = serializer(_queryCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCategoriesResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _category: _category,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __queryCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.QueryCategories',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCategories.fromReq = fromReq;
    __queryCategories.__isAmbassador = true;
    return __queryCategories;
}
/** Retrieves a list of categories by ids. */
export function listCompactCategoriesByIds(payload) {
    var _a = serializer(_listCompactCategoriesByIdsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCompactCategoriesByIdsResponse, {}).fromJSON;
    function __listCompactCategoriesByIds(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.ListCompactCategoriesByIds',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/list-by-ids',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCompactCategoriesByIds.fromReq = fromReq;
    __listCompactCategoriesByIds.__isAmbassador = true;
    return __listCompactCategoriesByIds;
}
/**
 * Retrieves a list of up to 1,000 categories, given the provided filtering, sorting, and cursor paging.
 * Pass supported values to the `fields` array in the request to include those fields in the response.
 *
 *
 * Search Categories runs with these defaults, which you can override:
 *
 * - `createdDate` is sorted in `DESC` order
 * - `cursorPaging.limit` is `100`
 *
 * For field support for filters and sorting,
 * see [Categories: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-management/categories/supported-filters-and-sorting).
 *
 * To learn about working with _Search_ endpoints, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language),
 * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
 */
export function searchCategories(payload) {
    var _a = serializer(_searchCategoriesRequest, {
        _aggregationNestedAggregation: _aggregationNestedAggregation,
        _aggregationRangeAggregation: _aggregationRangeAggregation,
        _commonAggregation: _commonAggregation,
        _cursorSearch: _cursorSearch,
        _nestedAggregationNestedAggregationItem: _nestedAggregationNestedAggregationItem,
        _rangeAggregationRangeBucket: _rangeAggregationRangeBucket,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchCategoriesResponse, {
        _aggregationData: _aggregationData,
        _aggregationResults: _aggregationResults,
        _aggregationResultsScalarResult: _aggregationResultsScalarResult,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _category: _category,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _groupByValueResults: _groupByValueResults,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _nestedAggregationResults: _nestedAggregationResults,
        _nestedResultValue: _nestedResultValue,
        _nestedResults: _nestedResults,
        _nestedValueAggregationResult: _nestedValueAggregationResult,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _rangeAggregationResult: _rangeAggregationResult,
        _rangeResult: _rangeResult,
        _rangeResults: _rangeResults,
        _results: _results,
        _richContent: _richContent,
        _scalarResult: _scalarResult,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __searchCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.SearchCategories',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchCategories.fromReq = fromReq;
    __searchCategories.__isAmbassador = true;
    return __searchCategories;
}
/**
 * Counts the number of categories that match the provided filtering.
 *
 * For field support for filters and sorting,
 * see [Categories: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-management/categories/supported-filters-and-sorting).
 */
export function countCategories(payload) {
    var _a = serializer(_countCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countCategoriesResponse, {}).fromJSON;
    function __countCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.CountCategories',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countCategories.fromReq = fromReq;
    __countCategories.__isAmbassador = true;
    return __countCategories;
}
/** Moves a category within its parent category, or to a different parent category. */
export function moveCategory(payload) {
    var _a = serializer(_moveCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_moveCategoryResponse, {}).fromJSON;
    function __moveCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.MoveCategory',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/{categoryId}/move',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __moveCategory.fromReq = fromReq;
    __moveCategory.__isAmbassador = true;
    return __moveCategory;
}
/**
 * Creates multiple categories.
 * Phase 2
 */
export function bulkCreateCategories(payload) {
    var _a = serializer(_bulkCreateCategoriesRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _category: _category,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateCategoriesResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _bulkCategoriesResult: _bulkCategoriesResult,
        _category: _category,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __bulkCreateCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.BulkCreateCategories',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/bulk/categories/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateCategories.fromReq = fromReq;
    __bulkCreateCategories.__isAmbassador = true;
    return __bulkCreateCategories;
}
/**
 * Updates multiple categories.
 *
 * Each time a category is updated, `revision` increments by 1.
 * The current `revision` must be passed when updating a category.
 * This ensures you're working with the latest category and prevents unintended overwrites.
 */
export function bulkUpdateCategories(payload) {
    var _a = serializer(_bulkUpdateCategoriesRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _category: _category,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _maskedCategory: _maskedCategory,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateCategoriesResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _bulkCategoriesResult: _bulkCategoriesResult,
        _category: _category,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __bulkUpdateCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.BulkUpdateCategories',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/bulk/categories/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateCategories.fromReq = fromReq;
    __bulkUpdateCategories.__isAmbassador = true;
    return __bulkUpdateCategories;
}
/**
 * Updates category visibility.
 *
 *
 * Each time a category is updated, `revision` increments by 1.
 * The current `revision` must be passed when updating a category.
 * This ensures you're working with the latest category and prevents unintended overwrites.
 */
export function updateCategoryVisibility(payload) {
    var _a = serializer(_updateCategoryVisibilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCategoryVisibilityResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _category: _category,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __updateCategoryVisibility(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'PATCH',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.UpdateCategoryVisibility',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/visibility',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCategoryVisibility.fromReq = fromReq;
    __updateCategoryVisibility.__isAmbassador = true;
    return __updateCategoryVisibility;
}
/**
 * Update `visible` field for multiple categories. If visible is set to false, all subcategories will be set to `visible=false`
 * Phase 2
 */
export function bulkUpdateCategoryVisibility(payload) {
    var _a = serializer(_bulkUpdateCategoryVisibilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateCategoryVisibilityResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _bulkCategoriesResult: _bulkCategoriesResult,
        _category: _category,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __bulkUpdateCategoryVisibility(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.BulkUpdateCategoryVisibility',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/bulk/categories/update-visibility',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateCategoryVisibility.fromReq = fromReq;
    __bulkUpdateCategoryVisibility.__isAmbassador = true;
    return __bulkUpdateCategoryVisibility;
}
/**
 * Update `visible` field for categories which satisfy the provided filter. If visible is set to false, all subcategories will be set to `visible=false` as well
 * Phase 2
 */
export function bulkUpdateCategoryVisibilityByFilter(payload) {
    var _a = serializer(_bulkUpdateCategoryVisibilityByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateCategoryVisibilityByFilterResponse, {}).fromJSON;
    function __bulkUpdateCategoryVisibilityByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.BulkUpdateCategoryVisibilityByFilter',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/bulk/categories/update-visibility-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateCategoryVisibilityByFilter.fromReq = fromReq;
    __bulkUpdateCategoryVisibilityByFilter.__isAmbassador = true;
    return __bulkUpdateCategoryVisibilityByFilter;
}
/**
 * Deletes multiple categories.
 * Phase 2
 */
export function bulkDeleteCategories(payload) {
    var _a = serializer(_bulkDeleteCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteCategoriesResponse, {}).fromJSON;
    function __bulkDeleteCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.BulkDeleteCategories',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/bulk/categories/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteCategories.fromReq = fromReq;
    __bulkDeleteCategories.__isAmbassador = true;
    return __bulkDeleteCategories;
}
/**
 * Delete multiple categories which satisfy the provided filter.
 * Phase 2
 */
export function bulkDeleteCategoriesByFilter(payload) {
    var _a = serializer(_bulkDeleteCategoriesByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteCategoriesByFilterResponse, {}).fromJSON;
    function __bulkDeleteCategoriesByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.BulkDeleteCategoriesByFilter',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/bulk/categories/delete-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteCategoriesByFilter.fromReq = fromReq;
    __bulkDeleteCategoriesByFilter.__isAmbassador = true;
    return __bulkDeleteCategoriesByFilter;
}
/** Adds multiple items to a single category. */
export function bulkAddItemsToCategory(payload) {
    var _a = serializer(_bulkAddItemsToCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkAddItemsToCategoryResponse, {}).fromJSON;
    function __bulkAddItemsToCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.BulkAddItemsToCategory',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/bulk/categories/{categoryId}/add-items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkAddItemsToCategory.fromReq = fromReq;
    __bulkAddItemsToCategory.__isAmbassador = true;
    return __bulkAddItemsToCategory;
}
/** Adds a single item to multiple categories. */
export function bulkAddItemToCategories(payload) {
    var _a = serializer(_bulkAddItemToCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkAddItemToCategoriesResponse, {}).fromJSON;
    function __bulkAddItemToCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.BulkAddItemToCategories',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/bulk/categories/add-item',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkAddItemToCategories.fromReq = fromReq;
    __bulkAddItemToCategories.__isAmbassador = true;
    return __bulkAddItemToCategories;
}
/** Removes multiple items from a single category. */
export function bulkRemoveItemsFromCategory(payload) {
    var _a = serializer(_bulkRemoveItemsFromCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkRemoveItemsFromCategoryResponse, {}).fromJSON;
    function __bulkRemoveItemsFromCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.BulkRemoveItemsFromCategory',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/bulk/categories/{categoryId}/remove-items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkRemoveItemsFromCategory.fromReq = fromReq;
    __bulkRemoveItemsFromCategory.__isAmbassador = true;
    return __bulkRemoveItemsFromCategory;
}
/** Removes a single item from multiple categories. */
export function bulkRemoveItemFromCategories(payload) {
    var _a = serializer(_bulkRemoveItemFromCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkRemoveItemFromCategoriesResponse, {}).fromJSON;
    function __bulkRemoveItemFromCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.BulkRemoveItemFromCategories',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/bulk/categories/remove-item',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkRemoveItemFromCategories.fromReq = fromReq;
    __bulkRemoveItemFromCategories.__isAmbassador = true;
    return __bulkRemoveItemFromCategories;
}
/**
 * Retrieves a list of up to 100 items from a single category, given the provided cursor paging.
 *
 *
 * List Items In Categories defaults to sorting by the time the item was added to the category, in descending order.
 */
export function listItemsInCategory(payload) {
    var _a = serializer(_listItemsInCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listItemsInCategoryResponse, {}).fromJSON;
    function __listItemsInCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.ListItemsInCategory',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/{categoryId}/list-items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                        protoPath: '/v1/categories/{categoryId}/list-items',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __listItemsInCategory.fromReq = fromReq;
    __listItemsInCategory.__isAmbassador = true;
    return __listItemsInCategory;
}
/** Retrieves a list of categories that contain the specified item. */
export function listCategoriesForItem(payload) {
    var _a = serializer(_listCategoriesForItemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCategoriesForItemResponse, {}).fromJSON;
    function __listCategoriesForItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.ListCategoriesForItem',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/list-categories-for-item',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                        protoPath: '/v1/categories/list-categories-for-item',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __listCategoriesForItem.fromReq = fromReq;
    __listCategoriesForItem.__isAmbassador = true;
    return __listCategoriesForItem;
}
/** Retrieves a list of all trees installed on the site, sorted by `appNamespace` in ascending order. */
export function listTrees(payload) {
    var _a = serializer(_listTreesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listTreesResponse, {}).fromJSON;
    function __listTrees(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'GET',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.ListTrees',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/list-trees',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listTrees.fromReq = fromReq;
    __listTrees.__isAmbassador = true;
    return __listTrees;
}
/**
 * Changes position of `item` in category. Will be used when sort items by manual arrangement
 *
 * > **Notes:**
 * > + If `position.BEFORE` is passed, then beforeItem must be provided.
 */
export function moveItemInCategory(payload) {
    var _a = serializer(_moveItemInCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_moveItemInCategoryResponse, {}).fromJSON;
    function __moveItemInCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.MoveItemInCategory',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/{categoryId}/move-item',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __moveItemInCategory.fromReq = fromReq;
    __moveItemInCategory.__isAmbassador = true;
    return __moveItemInCategory;
}
/**
 * Sets arranged items in a category.
 *
 * The order of items in the `items` array determines the order of items in the category.
 * The category's existing list of arranged items will be overridden.
 */
export function setArrangedItems(payload) {
    var _a = serializer(_setArrangedItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setArrangedItemsResponse, {}).fromJSON;
    function __setArrangedItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.SetArrangedItems',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/{categoryId}/set-arranged-items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setArrangedItems.fromReq = fromReq;
    __setArrangedItems.__isAmbassador = true;
    return __setArrangedItems;
}
/** Retrieves a list of arranged items in a category. */
export function getArrangedItems(payload) {
    var _a = serializer(_getArrangedItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getArrangedItemsResponse, {}).fromJSON;
    function __getArrangedItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'GET',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.GetArrangedItems',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/{categoryId}/arranged-items',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getArrangedItems.fromReq = fromReq;
    __getArrangedItems.__isAmbassador = true;
    return __getArrangedItems;
}
/** Retrieves the whole categories tree */
export function getCategoriesTree(payload) {
    var _a = serializer(_getCategoriesTreeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCategoriesTreeResponse, {
        _categoryTreeNode: _categoryTreeNode,
    }).fromJSON;
    function __getCategoriesTree(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.categories.v1.category',
            method: 'POST',
            methodFqn: 'com.wix.categories.api.v1.CategoriesService.GetCategoriesTree',
            url: resolveComWixCategoriesApiV1CategoriesServiceUrl({
                protoPath: '/v1/categories/get-tree',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCategoriesTree.fromReq = fromReq;
    __getCategoriesTree.__isAmbassador = true;
    return __getCategoriesTree;
}
//# sourceMappingURL=http.impl.js.map